import { useTemplateStore } from '@/stores/template';

export default {
  data() {
    return {
      templateStore: useTemplateStore()
    };
  }
};
